// @flow

const LocalStorageService = (function() {
  let _service;

  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }

  function _setToken(tokenObj: Object) {
    localStorage.setItem("access_token", tokenObj.token);
    localStorage.setItem("refresh_token", tokenObj.refreshToken);
  }

  function _getAccessToken() {
    return localStorage.getItem("access_token");
  }

  function _getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }

  function _clearToken() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    _clearImpersonate();
  }

  function _impersonate() {
    localStorage.setItem("impersonate", "true");
  }

  function _getImpersonate() {
    return localStorage.getItem("impersonate");
  }

  function _clearImpersonate() {
    localStorage.removeItem("impersonate");
  }

  function _setItem(item: string, value: boolean | string | number | Object) {
    return localStorage.setItem(item, JSON.stringify(value)); // The localStorage can handle only strings as values
  }
  function _getItem(item: string) {
    const lsItem = localStorage.getItem(item);
    return lsItem && JSON.parse(lsItem); // The localStorage can handle only strings as values
  }
  function _removeItem(item: string) {
    return localStorage.removeItem(item);
  }

  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    setImpersonate: _impersonate,
    getImpersonate: _getImpersonate,
    clearImpersonate: _clearImpersonate,
    setItem: _setItem,
    getItem: _getItem,
    removeItem: _removeItem,
  };
})();

export default LocalStorageService;
